import { api } from '@cwd/lib/main';

export interface AccountListItem {
    AccountId: string;
    AccountName: string;
    ClientCompanyId: string;
    // ServiceSubscriptionId: string;
    // ClientCompanyName: string;
}

export interface DataSourceListItem {
    DataSourceId: string;
    AccountId: string;
    Name: string;
    SourceType: number;
    IsTemplate: boolean;
    IsGlobal?: boolean;
}

export interface AccountDataSourceListItem {
    AccountId: string;
    DataSourceId: string;
    AccountName: string;
    ClientCompanyId: string;
    ClientCompanyName?: string;
}

export async function getTemplateDataSources(): Promise<DataSourceListItem[]> {
    return api.get('/DataSources/Template');
}

export async function getAccountDataSourceListItems(): Promise<AccountDataSourceListItem[]> {
    return api.get('/DataSources/Account');
}

export async function addAccountToDataSource(dataSourceId: string, accountId: string): Promise<string> {
    return api.post('/DataSources/' + dataSourceId + '/Accounts/' + accountId + '/Add');
}

export async function removeAccountFromDataSource(dataSourceId: string, accountId: string): Promise<void> {
    return api.delete('/DataSources/' + dataSourceId + '/Accounts/' + accountId + '/Remove');
}

export async function addAllSiblingAccountsToDataSource(dataSourceId: string, accountId: string): Promise<string[]> {
    return api.post('/DataSources/' + dataSourceId + '/Accounts/' + accountId + '/AddAllSiblings');
}

export async function removeAllSiblingAccountsFromDataSource(dataSourceId: string, accountId: string): Promise<void> {
    return api.delete('/DataSources/' + dataSourceId + '/Accounts/' + accountId + '/RemoveAllSiblings');
}
